.wrap {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.input {
  width: 64px;
  height: 32px;
  padding: 0 8px;
  border: 1px solid var(--border-control);
  border-radius: var(--radius-sm);
  background: var(--surface);
  font-size: var(--font-size);
  font-variant-numeric: tabular-nums;
  text-align: center;
}

.input:focus-visible {
  outline: 2px solid var(--accent);
  outline-offset: -1px;
}

.input:disabled {
  color: var(--text-muted);
  background: var(--surface-muted);
}

.invalid {
  border-color: var(--danger);
}

/* Past 24:00 of the personal day (2026-10b §3.8). */
.nextDay {
  color: var(--text-muted);
  font-size: 11px;
}

/* Touch: 44px controls and 16px text so iOS does not zoom on focus (2026-10b §3.8). */
@media (pointer: coarse) {
  .input {
    width: 76px;
    height: 44px;
    font-size: 16px;
  }
}
